import {Injectable} from '@angular/core';
import {Dtos} from '../utils/dtos';
import {FilterService} from './filterer/filter.service';
import {DataManipulationService} from './common/data-manipulation.service';
import {BaseService} from './common/base.service';
import {ValidatorService} from './common/validator.service';
import {MbColDefinition, MbColInput} from '../components/mb-datatable/models/mb-datatable.model';
import {DashboardMessageRepository} from '../repositories/dashboard-message.repository';
import {Utilities} from '../utils/utilities';
import {MbDatatablesTemplate} from '../components/mb-datatable/mb-datatables-template';

@Injectable({
    providedIn: 'root'
})
export class DashboardMessageService extends BaseService<DashboardMessageRepository> {


    constructor(repo: DashboardMessageRepository, filterService: FilterService, dataManipulationService: DataManipulationService, validatorService: ValidatorService) {
        super(repo, filterService, dataManipulationService, validatorService);
        this.typeName = 'DashboardMessage';
    }

    getAllForDashboardTable() {
        const filter = this.filterService.filter(Dtos.DASHBOARD_MESSAGE.DashboardMessageDTO)
            .equal('deleted', false)
            .create();
        return this.repo.getAllByFilter(filter);
    }
    getAllForNavBar() {
        const now = Utilities.dateToBackendDateTimeString(new Date());
        const filter = this.filterService.filter(Dtos.DASHBOARD_MESSAGE.DashboardMessageDTO)
            .equal('deleted', false)
            .and()
            .lessThan('visibilityStart', now)
            .and()
            .greaterThan('visibilityEnd', now)
            .create();
        return this.repo.getAllByFilter(filter);
    }

    addExtraDataForOne(model: any): any {
        model = this.dataManipulationService.addLocalizedAttributeToElement(model, 'title');
        model = this.dataManipulationService.addLocalizedAttributeToElement(model, 'message');
        return model;
    }

    protected defineModelSpecificColumns(extraInfo?: any): any[] {
        return [
            MbColDefinition.new('title', 'dashboardMessage.label.title'),
            MbColDefinition.new('visibilityStart', 'dashboardMessage.label.visibilityStart', MbColInput.newDefaultText(), MbDatatablesTemplate.DATETIME_TEMPLATE),
            MbColDefinition.new('visibilityEnd', 'dashboardMessage.label.visibilityEnd', MbColInput.newDefaultText(), MbDatatablesTemplate.DATETIME_TEMPLATE),
        ];
    }

    validate(model: any) {
        this.validatorService.allRequired(model, ['localizations', 'visibilityStartDate', 'visibilityEndDate'], 'DashboardMessage');
        this.validatorService.backendMapIsEmpty(model.localizations, 'DashboardMessage');
        if (!model.localizations.hu.title) {
            throw new Error('error.dashboardMessage.noTitle');
        }
        if (!model.localizations.hu.message) {
            throw new Error('error.dashboardMessage.noMessage');
        }
        if (model.visibilityStartDate > model.visibilityEndDate) {
            throw new Error('error.dashboardMessage.dateError');
        }
    }

    saveOrUpdate(dashboardMessage: DashboardMessage) {
        dashboardMessage.visibilityEnd = Utilities.dateToBackendDateEndOfDayString(dashboardMessage.visibilityEndDate)
        dashboardMessage.visibilityStart = Utilities.dateToBackendDateStartOfDayString(dashboardMessage.visibilityStartDate)
        return this.save(dashboardMessage);
    }
}

export class DashboardMessage {
    id: number = null;
    localizations: { [key: string]: DashboardMessageLocalized };
    private _visibilityStartDate: Date = new Date();
    private _visibilityEndDate: Date = Utilities.addDays(new Date(), 4);
    visibilityStart: string = Utilities.dateToBackendDateStartOfDayString(this._visibilityStartDate,true);
    visibilityEnd: string = Utilities.dateToBackendDateEndOfDayString(this._visibilityEndDate,true);

    constructor() {
        this.localizations = {};
    }


    get visibilityStartDate(): Date {
        return this._visibilityStartDate;
    }

    set visibilityStartDate(value: Date) {
        this.visibilityStart = Utilities.dateToBackendDateStartOfDayString(value,true)
        this._visibilityStartDate = value;
    }

    get visibilityEndDate(): Date {
        return this._visibilityEndDate;
    }

    set visibilityEndDate(value: Date) {
        this.visibilityEnd = Utilities.dateToBackendDateEndOfDayString(value,true);
        this._visibilityEndDate = value;
    }
}

export class DashboardMessageLocalized {
    message: string;
    title: string;

    constructor(message: string, title: string) {
        this.message = message;
        this.title = title;
    }
}
